import { cn } from '@seen/ui'
import type { JSX, ReactNode } from 'react'

export interface FilterBarProps {
  children: ReactNode
  hasActiveFilters?: boolean
  onClearAll?: () => void
  className?: string
}

export function FilterBar({
  children,
  hasActiveFilters,
  onClearAll,
  className,
}: FilterBarProps): JSX.Element {
  return (
    <div className={cn('flex flex-wrap items-center gap-2', className)}>
      {children}
      {hasActiveFilters && onClearAll && (
        <button
          type="button"
          onClick={onClearAll}
          className="text-sm text-zinc-500 hover:text-zinc-700 hover:underline dark:text-zinc-400 dark:hover:text-zinc-200"
        >
          Clear filters
        </button>
      )}
    </div>
  )
}
